import { FC, useEffect } from 'react'

import { IconClock, Badge } from '@sequencehq/core-components'

import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const BadgeNeedsReview = (props: { quoteId: string }) => {
  const cubeContext = useCubeContext()
  const resAutomationExecutions = useQuery(
    dashboardv99990101Client.getAutomationExecutions,
    {
      triggerType: 'QUOTE_REQUIRES_APPROVAL',
      status: 'RUNNING',
      quoteId: props.quoteId
    },
    {
      refetchInterval: 3000
    }
  )

  /**
   * If there are no running automation executions for quote approval,
   * then we can assume the quote is no longer waiting for review and
   * trigger a refetch of the quote data to update the UI accordingly.
   */
  useEffect(() => {
    if (
      !resAutomationExecutions.error &&
      !resAutomationExecutions.isPending &&
      resAutomationExecutions.data?.items.length === 0
    ) {
      cubeContext.mutators.external.in.core()
    }
  }, [resAutomationExecutions, cubeContext.mutators.external.in.core])

  return (
    <Badge
      sentiment="highlight"
      size="md"
      textTransform="none"
      data-testid="quote.header.needsReviewBadge"
    >
      <IconClock />
      Waiting for review
    </Badge>
  )
}
